import { Component, inject } from '@angular/core';
import { CustomModalService } from '../modal/custom-modal.service';
import { LoginAttemptService } from '@piqet-angular/features';
import { AuthFacade } from '@piqet-angular/data';

@Component({
  selector: 'piqet-angular-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss'],
})
export class InstructionsComponent {
  modal = inject(CustomModalService);
  loginAttemptService = inject(LoginAttemptService);
  authFacade = inject(AuthFacade);

  private resetAndCloseModal(): void {
    this.loginAttemptService.resetAttempts();
    this.authFacade.clearMaxLoginAttempts();
    this.modal.close();
  }

  onClose(): void {
    this.resetAndCloseModal();
  }

  contactSupport(): void {
    window.location.href = 'mailto:support@piqet.com';
    this.resetAndCloseModal();
  }
}
